import EmptyComponent from '@/components/EmptyComponent'

const route = (path, name, options = {}) => {

    const children = options.children || null;

    const components = {
        default: (options && options.components && options.components.main) || EmptyComponent,
        sidebar: (options && options.components && options.components.sidebar) || EmptyComponent
    }

    const meta = {
        layout: options.layout || 'LayoutBlank',
        requiresAuth: (options && options.requiresAuth) || false,
        pageTitle: options.title || '',
        breadcrumb: options.breadcrumb || [],
    };

    return {
        path,
        name,
        components: components,
        children,
        props: true,
        meta: meta
    }
}

export {
    route
}
